import React, { FunctionComponent, useState } from 'react';
import Styles from 'components/timeFormat/TimeFormat.module.scss';
import ModalShell from 'components/chatModal/ChatModalShell.module.scss';
import RadioButton from 'components/button/radioButton/RadioButton';
import { time } from 'helpers/data/dateAndTime';

interface TimeFormatProps {
  handleClose: Function;
  selectedValue?: string;
}

const TimeFormat: FunctionComponent<TimeFormatProps> = (props: TimeFormatProps) => {
  const { handleClose, selectedValue = '' } = props;
  const [value, setValue] = useState(selectedValue);
  const handleDone = () => handleClose(value || selectedValue);
  const handleChange = (event: React.FormEvent<HTMLInputElement>) => {
    setValue(event.currentTarget.value);
  };

  return (
    <>
      <div className={Styles.optionsList}>
        {time.map((t) => (
          <div
            className={Styles.optionRow}
            key={t.value}
            onClick={() => setValue(t.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                setValue(t.value);
              }
            }}
            role="button"
            tabIndex={0}
          >
            <div className={Styles.optionText}>
              <p className={Styles.optionTitle}>{t.format}</p>
              <span className={Styles.optionDetail}>{t.detail}</span>
            </div>
            <RadioButton
              name="time_format"
              value={t.value}
              checked={value === t.value}
              handleChange={handleChange}
            />
          </div>
        ))}
      </div>
      <div className={ModalShell.footer}>
        <button type="button" className={Styles.doneBtn} onClick={handleDone}>
          Done
        </button>
      </div>
    </>
  );
};

export default TimeFormat;
